import { Injectable } from '@angular/core';
import { PrintCardContentViewModel } from '../../shared/print-card-content-view-model';
import { Observable } from 'rxjs';
import { FikaConcentrateCardData } from '../../../../../../../models/print-cards/fika-concentrate-card-data';
import { map } from 'rxjs/operators';
import { AssetUtils } from '../../../../../../../utils/asset-utils';

@Injectable()
export class FikaConcentrateAddressCardStackContentViewModel extends PrintCardContentViewModel {
  public readonly cardData$: Observable<FikaConcentrateCardData>;
  public readonly cardAssetUrl$ = this.cardData$.pipe(
    map(cardData => AssetUtils.budSenseProductTypeUrlsFromCardData(cardData))
  );
}
